import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, countries, profile } from 'config/config'; // Importing configuration settings

/**
 * FilterCompetitorsView class extends JetView to create a filter form for competitors.
 */
export default class FilterCompetitorsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Id
                            name: 'Id',
                            type: 'number',
                            label: _("<span class='icon-id'></span> Id"),
                            labelPosition: 'top',
                            placeholder: _('Id'),
                        },
                        {
                            view: 'text', // Input for Name
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country flags
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Country data
                                },
                            },
                            // Conditional visibility based on configuration
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Read-only dropdown for selected country
                            name: 'CountrySelect2',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default value from profile
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country flags
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Country data
                                },
                            },
                            // Conditional visibility based on configuration
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'country-hide prm-filterByCountry',
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section of the form
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 190 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        const buttons = {
            // Button section
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Placeholder for layout
                        {
                            view: 'button', // Button to add competitor
                            value: _('Añadir Competidor'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('competitorsAdd', 'Add'), // Conditional visibility
                            css: 'prm-competitorsAdd',
                            width: screen == 'small' ? 0 : 160,
                            minWidth: 200,
                            click: () => {
                                // Click event to add competitor
                                this.app.callEvent('addCompetitor:button', [[]]);
                            },
                        },
                        {
                            view: 'button', // Button to clear form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Click event to clear form
                                this.getRoot().clear();
                            },
                        },
                        {
                            view: 'button', // Button to consult competitors
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Click event to filter competitors
                                const filterdata = this.getRoot().getValues();
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                                }
                                delete filterdata['CountrySelect2']; // Remove unused field
                                this.app.callEvent('competitors:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
